import { BidManagementTabsEnum } from './BidManagementPage';

export const checkIsTabCorrect = (tab: string | null) => {
  return (
    tab === BidManagementTabsEnum.AllBids ||
    tab === BidManagementTabsEnum.ApprovedBuyers ||
    tab === BidManagementTabsEnum.PendingRequests
  );
};
